import Head from "next/head";
import { InventoryProps } from "../mock";
import ClientFilter from "./client-filter";

import styles from "./vehile-inventory.module.scss";

import { Suspense } from "react";
import { Filter1Skeleton } from "./skeleton";
import { BuyerPreference } from "./handle-buyer-preference";
import { setPref } from "./action";
import { VehicleContainer } from "./vehicles-container";
import {
  handleFormatStyleString,
  toJsonLd,
} from "@/components/package-components/utils";
import {
  BuyerPreferenceEnum,
  Vehicle,
} from "@/components/package-components/types";

export function Filter1(props: InventoryProps) {
  let pref: BuyerPreferenceEnum | undefined;

  const vehicles = props.data?.filteredList
    ? props.data?.filteredList
    : props.data?.vehicleList;

  const itemListElement =
    vehicles &&
    vehicles.map((vehicle: Vehicle) => {
      const { make, model } = vehicle;

      const offer = {
        "@type": "Offer",
        itemOffered: {
          "@type": "CarDealership",
          name: `${make} ${model}`,
        },
      };

      return offer;
    });

  const object = {
    "@context": "https://schema.org",
    "@type": "CarDealership",
    name: "Estoque",
    description:
      "Encontre a melhor seleção de veículos para venda com opções de filtragem personalizadas. Explore nossa ampla variedade de carros disponíveis e refine sua busca por marca, modelo, preço e muito mais. Encontre o veículo dos seus sonhos aqui!",
    itemListElement: itemListElement ?? [],
  };

  if (props?.data?.shouldRenderDetail == true) {
    return <></>;
  }

  return (
    <>
      {props && props.styles && props.styles.value && (
        <style>
          {handleFormatStyleString(props.styles.value as string, props.id)}
        </style>
      )}

      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={toJsonLd("CarDealership", { ...object })}
        />
      </Head>

      <Suspense fallback={<Filter1Skeleton {...props} />}>
        <BuyerPreference props={props} setPreference={setPref} prefVar={pref}>
          <ClientFilter props={props}>
            <main
              className={`${styles.main} main-${props.id} ${
                Boolean(
                  props.options?.showMakeFilter?.value ||
                    props.options?.showMakeFilter
                ) == false &&
                Boolean(
                  props.options?.showModelFilter?.value ??
                    props.options?.showModelFilter
                ) == false
                  ? `${styles["main--4col"]} main--4col-${props.id}`
                  : ""
              }`}
            >
              <VehicleContainer props={props} />
            </main>
          </ClientFilter>
        </BuyerPreference>
      </Suspense>
    </>
  );
}
